<template>
  <div style="padding-top: 40px;">
    <div class="search">
      <div class="search-input">
        <input v-model="filters.q" type="search" @search="search">
      </div>
      <a href="javascript:void(0)" class="btn-filters" @click="btnFilterClickedHandler">筛选</a>
    </div>

    <p v-if="taxFilings.length<=0 && showLoading===false" class="center" style="margin-top:12px;font-size: 14px;">
      暂无报税记录
    </p>
    <TaxFilingItem
      v-for="c in taxFilings"
      v-else
      :key="c.taxFilingId"
      :r10="c.r10"
      :r20="c.r20"
      :r31="c.r31"
      :r32="c.r32"
      :r40="c.r40"
      :r50="c.r50"
      :show-r10="tempCategory.indexOf('r10')>-1"
      :show-r20="tempCategory.indexOf('r20')>-1"
      :show-r31="tempCategory.indexOf('r31')>-1"
      :show-r32="tempCategory.indexOf('r32')>-1"
      :show-r40="tempCategory.indexOf('r40')>-1"
      :show-r50="tempCategory.indexOf('r50')>-1"
      :period="c.period"
      :month="c.month"
      :type="c.type"
      :company-name="c.companyName"
      :tax-filing-id="c.taxFilingId"/>


    <!--筛选详情-->
    <div v-if="showFilter" class="filters">
      <div class="detail">
        <p class="title">申报类型</p>
        <div class="flex mb-3">
          <a
            v-for="(item,index) in types"
            :key="index"
            href="javascript:void(0)"
            class="btn-type"
            :class="item===filters.type?'selected':''"
            @click="typeClickedHandler(item)">{{ item }}</a>
        </div>
        <p class="title">申报周期</p>
        <div class="flex mb-3">
          <a
            v-for="(item,index) in periods"
            :key="index"
            href="javascript:void(0)"
            class="btn-type"
            :class="item===filters.period?'selected':''"
            @click="periodClickedHandler(item)">{{ item }}</a>
        </div>
        <p class="title">申报月份</p>
        <div class="flex mb-3">
          <input
            ref="signedDate"
            :value="filters.signedDate"
            class="input-picker"
            type="text"
            placeholder="申报月份"
            @change="filters.signedDate=refSignedDate.getDate('YYYY-MM')">
        </div>
        <p class="title">税种</p>
        <div class="flex mb-3 wrap">
          <a
            v-for="(item,index) in categories"
            :key="index"
            href="javascript:void(0)"
            class="btn-type e3"
            :class="category.indexOf(item.value)>-1?'selected':''"
            @click="categoryClickedHandler(item.value)">{{ item.text }}</a>
        </div>
      </div>

      <div class="btns">
        <a href="javascript:void(0)" class="btn-reset" @click="reset">重置</a>
        <a href="javascript:void(0)" class="btn-confirm" @click="confirm">确定</a>
      </div>
    </div>
    <!--筛选详情-->
  </div>
</template>

<script>
  import TaxFilingItem from "../../components/TaxFilingItem";
  import {mapGetters, mapActions} from 'vuex';
  import 'pickerjs/dist/picker.min.css'
  import Picker from 'pickerjs/dist/picker.min';

  export default {
    name: "TaxFilings",
    components: {
      TaxFilingItem,
    },
    computed: {
      ...mapGetters(['taxFilings', 'showLoading']),
    },
    methods: {
      ...mapActions(['getTaxFilings']),
      typeClickedHandler(type) {
        if (type === this.filters.type) {
          this.filters.type = '';
        } else {
          this.filters.type = type;
        }
      },
      periodClickedHandler(type) {
        if (type === this.filters.period) {
          this.filters.period = '';
        } else {
          this.filters.period = type;
        }
      },
      categoryClickedHandler(type) {

        let index = this.category.indexOf(type);
        if(index>-1){
          this.category.splice(index,1);
        }else{
          this.category.push(type);
        }
      },
      btnFilterClickedHandler() {
        this.showFilter = !this.showFilter;

        if (!this.showFilter) {
          return;
        }

        setTimeout(() => {
          const config = {
            format: 'YYYY-MM',
            text: {
              title: '选择时间',
              cancel: '取消',
              confirm: '确定'
            }
          };
          this.refSignedDate = new Picker(this.$refs.signedDate, config);
        }, 100)
      },
      reset() {
        for (let key in this.filters) {
          this.filters[key] = '';
        }
        this.category=["r10", "r20", "r31", "r32", "r40", "r50"];
      },
      confirm() {
        this.showFilter = false;

        let params = {
          companyId: this.currentUser.companyId || null,
          type: this.filters.type,
          period: this.filters.period,
          month:this.filters.signedDate?this.filters.signedDate+'-01':'',
          q: this.filters.q,
          showR10: this.category.indexOf('r10') > -1,
          showR20: this.category.indexOf('r20') > -1,
          showR31: this.category.indexOf('r31') > -1,
          showR32: this.category.indexOf('r32') > -1,
          showR40: this.category.indexOf('r40') > -1,
          showR50: this.category.indexOf('r50') > -1,
        };

        this.tempCategory = [...this.category];
        this.getTaxFilings({ts: '', params: params});
      },
      search() {
        let params = {
          companyId: this.currentUser.companyId || null,
          q: this.filters.q
        };
        this.getTaxFilings({ts: '', params: params});
      }
    },
    data() {
      return {
        types: ["基本税率", "差额征税", "核定征收"],
        periods: ["季报", "月报"],
        categories: [
          {text: "增值税", value: "r10"},
          {text: "附加税", value: "r20"},
          {text: "个人所得税", value: "r31"},
          {text: "企业所得税", value: "r32"},
          {text: "印花税", value: "r40"},
          {text: "工会经费", value: "r50"},
        ],
        category: ["r10", "r20", "r31", "r32", "r40", "r50"],
        tempCategory: ["r10", "r20", "r31", "r32", "r40", "r50"],
        showFilter: false,
        filters: {
          type: '',//申报类型
          period: '',//申报周期
          signedDate: '',
          q: ''
        },
        refSignedDate: null,
      }
    },
    created() {

      let params = {
        companyId: this.currentUser.companyId || null
      };
      this.getTaxFilings({ts: '', params: params});
    },
  }
</script>

<style scoped>
  .search {
    height: 40px;
    width: 100%;
    border-bottom: 1px solid #D8D8D8;
    display: flex;
    padding: 0 10px;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    z-index: 9;
    background: #fff;
    top: 0;
    left: 0;
  }

  .search .search-input {
    padding: 0 10px 0 30px;
    height: 30px;
    opacity: 1;
    border-radius: 4px;
    border: none;
    outline: none;
    flex: 1 1 auto;
    background: rgba(242, 242, 242, 1) url('../../assets/icon-search.png') 10px center no-repeat;
  }

  .search .search-input input {
    width: 100%;
    height: 30px;
    border: none;
    outline: none;
    background: transparent;
  }

  .search .btn-filters {
    text-decoration: none;
    color: #666;
    width: 50px;
    margin-left: 20px;
    position: relative;
  }

  .search .btn-filters::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #666;
    position: absolute;
    top: 8px;
    right: 0;
  }

  .filters {
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    height: calc(100vh - 40px);
    width: 100%;
    z-index: 11;
    top: 40px;
    left: 0;
  }

  .filters .detail {
    background: #fff;
    padding: 12px;
  }

  .filters .detail .title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  .filters .detail .flex {
    display: flex;
    justify-content: space-between;
  }

  .filters .detail .flex.wrap {
    flex-wrap: wrap;
  }

  .filters .detail .btn-type {
    flex-grow: 0.2;
    height: 27px;
    border-radius: 100px;
    text-decoration: none;
    font-size: 14px;
    text-align: center;
    line-height: 27px;
    background: #F2F2F2;
    border: 1px solid #F2F2F2;
    color: #262626;
  }

  .filters .detail .btn-type.e3 {
    width: 30%;
    margin-bottom: 10px;
  }

  .filters .detail .btn-type.selected {
    background: rgba(249, 237, 235, 1);
    border: 1px solid rgba(222, 62, 38, 1);
    color: #DE3E26;
  }

  .filters .detail .input-picker {
    height: 27px;
    background: rgba(242, 242, 242, 1);
    border-radius: 100px;
    border: none;
    outline: none;
    color: #999;
    text-align: center;
  }

  .filters .btns {
    background: #fff;
    height: 63px;
    border-top: 1px solid rgba(216, 216, 216, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .filters .btns a {
    text-decoration: none;
    margin: 0 10px;
    text-align: center;
    border-radius: 100px;
    flex-grow: 1;
    height: 35px;
    line-height: 33px;
  }

  .filters .btns a.btn-reset {
    border: 1px solid rgba(141, 141, 141, 1);
    color: #8D8D8D;
  }

  .filters .btns a.btn-confirm {
    border: 1px solid #FD493A;
    background: #FD493A;
    color: #fff;
  }
</style>